// API base address. Dev: empty string, CRA proxy forwards /api to :5001.
// Prod: set REACT_APP_API_BASE on the Railway frontend service to the backend's public URL.
const API_BASE = process.env.REACT_APP_API_BASE || '';
export default API_BASE;
